





import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { DomainRegistry } from "../../domain";
import { FormatReference } from "../../domain/format";
import { WindowsOpenRequest } from "../../domain/localhost/items";
import { WindowOpener } from "../system/utilities";

/**
 * 文書セットIDを指定して起動する場合は、ひとつの文書編集画面内で複数の文書を編集できるようにすることになる見込み
 * 現状ではそこまでの対応は出来ておらず、複数の文書編集画面を起動する機能があるのみ
 */
@Component({
  components: {
  },
})
export default class NewGroupedDocumentEditView extends Mixins() {
  @Prop()
  patientNo: string;

  @Prop()
  formatGroupId: number;

  @Prop()
  institutionNo: string;

  @Prop()
  regionalInstitutionNo: string;

  @Prop()
  hisInfoGetterParameter: string;

  @Prop()
  shouldCloseOnRegistered: boolean;

  @Prop()
  defaultToolTabName: string;

  @Prop()
  shouldIndicatePrintButtonForcibly: boolean;

  mounted() {
    this.openNewDocumentEditViews();
  }

  private async openNewDocumentEditViews(): Promise<void> {
    if (!this.patientNo) {
      this.$fatal("エラー", "患者番号が指定されていません。");
      return;
    }
    if (!this.formatGroupId) {
      this.$fatal("エラー", "フォーマットグループIDが指定されていません。");
      return;
    }
    const repo = DomainRegistry.format.getFormatRepository();
    const formatGroup = await repo.getFormatGroupInformation(this.formatGroupId);
    if (!formatGroup) {
      this.$fatal("エラー", "フォーマットグループの取得に失敗しました。");
      return;
    }
    if (formatGroup.isDeleted) {
      this.$fatal("エラー", "フォーマットグループが削除されています。");
      return;
    }
    const availableFormats = formatGroup.formats.filter(f => !f.deleted && !f.expired);
    if (availableFormats.length === 0) {
      this.$fatal("エラー", "フォーマットグループ内に記載可能なフォーマットがありません。");
      return;
    }
    if (this.$configuration.behavior.format.formatSet.shouldOpenWindowsWithUrlScheme) {
      const request = this.createWindowsOpenRequest(availableFormats, this.patientNo);
      await WindowOpener.requestOpenWindows(request);
    } else {
      for (const format of availableFormats) {
        try {
          // 連続で開くにはブラウザのpopup brokcerを解除しておく必要あり
          this.openEditNewDocumentWindow(format, this.patientNo);
        } catch (e) {
          this.$error("エラー", "新規ウィンドウを開く処理中にエラーが発生しました。", e);
        }
        // 不要かもだが念のためsleepを入れている
        await this.$sleep(100);
      }
    }
    // 即座に閉じるとウィンドウオープンの処理が中断されるため、sleepを追加している
    await this.$sleep(3000);
    this.$closeWindow(true);
  }

  private createWindowsOpenRequest(formats: FormatReference[], patientCode: string): WindowsOpenRequest {
    const request = new WindowsOpenRequest();
    request.urls = Enumerable.from(formats)
      .select(f => WindowOpener.toUrlEncodedUrl("/EditNewDocument", this.createOpenEditNewDocumentWindowParameter(f, patientCode)))
      .toArray();
    return request;
  }

  private openEditNewDocumentWindow(format: FormatReference, patientCode: string): void {
    this.$openWindow(
      "/EditNewDocument",
      this.createOpenEditNewDocumentWindowParameter(format, patientCode),
    );
  }

  private createOpenEditNewDocumentWindowParameter(format: FormatReference, patientCode: string): { [key: string]: string } {
    return {
      patientNo: patientCode,
      formatId: format.id.toString(),
      institutionNo: this.institutionNo,
      regionalInstitutionNo: this.regionalInstitutionNo,
      hisInfoGetterParameter: this.hisInfoGetterParameter,
      defaultToolTabName: this.defaultToolTabName,
      shouldIndicatePrintButtonForcibly: (this.shouldIndicatePrintButtonForcibly != null) ? this.shouldIndicatePrintButtonForcibly.toString() : null,
    };
  }
}
